import React, {useEffect} from "react";
import {AmchartSeeker, ModalSeeker} from "@ui-seeker/core";
import {useToast} from "../../../../@hooks";
import {AppButtonIcon} from "../../../../@components";
import {Box} from "@mui/material";


export default function FullScreenChartModal({ titleChart, filteredChart, seriesToApply, showByPrice, isOpen, toggleOpen, isDateAxis, xTitle, isRating, ...props }) {

    const { showToast } = useToast();

    useEffect(() => {
        if(isOpen) showToast.info("Press ESC to exit fullscreen mode")
    },[isOpen]);

    return <ModalSeeker
        isOpen={isOpen}
        controller={() => toggleOpen()}
        card={{ sx: { p: 0 } }}
        containerProps={{ fullScreen: true, sx: { '.MuiDialogContent-root': { p: 0 } }}}
        hideActions>
        <AmchartSeeker
            rootID="ChartSelectedFullscreen"
            data={filteredChart}
            series={seriesToApply.map(({ dataKey, color }) => ({
                name: dataKey,
                yField: dataKey,
                xField: 'date',
                color: color,
                connect: true,
                type: (titleChart !== 'Dates of Rental' && titleChart !== "Length of Rental") ? 'column' : 'line',
                tooltip: {
                    pointerOrientation: "horizontal",
                },
                tension: 1,
            }))}
            sx={{ height: '90vh' }}
            extraHeader={<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }} >
                <AppButtonIcon
                    sx={{ mr: 4 }}
                    onClick={() => toggleOpen()}
                    iconProps={{ iconWeight: "solid" }}
                    tooltip="Close Modal"
                    icon="xmark"
                />
            </Box>}
            chartProps={{
                showBullets: true,
                enabledPDF: false,
                numberFormat: `#,###.00 ' ${showByPrice !== "price" ? '%' : ""}'`,
                dateFormatReceived: 'yyyyMMdd',
                scrollbarY: {
                    show: true
                },
                xAxis: {
                    categoryField: 'date',
                    maxDeviation: 0.3,
                    isDateAxis: isDateAxis,
                    dateFormat: 'dd MMM yyyy (EEE)',
                    title: xTitle,
                    baseInterval: {
                        timeUnit: 'day',
                        count: 1
                    },
                    labelProps: {
                        rotation: filteredChart.some(({ date }) => date.length > 8) ? "10" : "0"
                    },
                    ...props.labelProps
                },
                yAxis: {
                    title: isRating ? 'Rating' : showByPrice === "price" ? 'Prices' : "Variation"
                },
            }}
        />
    </ModalSeeker>
}